import { defineMessages } from 'react-intl-next';

export const messages: {
    next: {
        defaultMessage: string;
        description: string;
        id: string;
    }; pause: {
        defaultMessage: string;
        description: string;
        id: string;
    }; play: {
        defaultMessage: string;
        description: string;
        id: string;
    }; previous: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	previous: {
		id: 'company-hub.carousel-extension.carousel-navigation.row-orientation.previous',
		defaultMessage: 'Previous',
		description:
			'Label text for the button that, when clicked, goes back one frame and displays the previous frame',
	},
	next: {
		id: 'company-hub.carousel-extension.carousel-navigation.row-orientation.next',
		defaultMessage: 'Next',
		description:
			'Label text for the button that, when clicked, goes forward one frame and displays the next frame',
	},
	play: {
		id: 'company-hub.carousel-extension.carousel-navigation.play',
		defaultMessage: 'Play',
		description: 'Label text for the button that, when clicked, autoplay carousel frames',
	},
	pause: {
		id: 'company-hub.carousel-extension.carousel-navigation.pause',
		defaultMessage: 'Pause',
		description: 'Label text for the button that, when clicked, pauses autoplay of carousel frames',
	},
});
